import _ from 'underscore';
import React from 'react';
import Joi from 'joi';
import { api as apiRequest } from '@culture/common-helpers/request';
import {
	addCleanCache,
	parsePathParams,
	prepareDateParams
} from '@culture/common-helpers/params';
import { filterQuery } from '@culture/common-helpers/url';
import MainTemplate from 'pageTemplates/main';
import { eventsOperations } from 'ducks/events';

import { initializeStore } from 'store';

const getInstitutes = ({ cleanCache }) => {
	const params = filterQuery({
		fields: [
			'_id',
			'title',
			'name',
			'thumbnailFile',
			'type',
			'locale',
			'foundationDate'
		].join(),
		sort: '-updateDate',
		cached: true,
		isMuseumExhibition: true,
		statuses: ['published'],
		limit: 10
	});

	return apiRequest('institutes', addCleanCache(params, cleanCache));
};

const Institutes = (props) => <MainTemplate {...props} />;

export async function getServerSideProps({ query }) {
	const validationSchema = Joi.object().keys({
		pathParams: Joi.array().items(Joi.string()),
		cleanCache: Joi.boolean(),
		query: Joi.string(),
		limit: Joi.number().default(6).min(1),
		locale: Joi.string()
	});

	const pathParamsValidationSchema = Joi.object().keys({
		seanceStartDate: Joi.date(),
		seanceEndDate: Joi.date(),
		season: Joi.string()
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const parsedPathParams = parsePathParams(params.pathParams);

	const pathParams = Joi.attempt(
		parsedPathParams.params,
		pathParamsValidationSchema,
		{ stripUnknown: true }
	);

	const dateParams = prepareDateParams(_(pathParams).omit('season'));
	const additionalParams = _(parsedPathParams.params).pick('season');

	const allParams = _({ ...params, ...dateParams, ...additionalParams }).omit(
		'pathParams'
	);

	const reduxStore = initializeStore();
	const { dispatch } = reduxStore;

	await dispatch(eventsOperations.getEventsCatalog({ ...allParams }));

	const { events } = reduxStore.getState();
	const { items: institutes } = await getInstitutes({
		cleanCache: params.cleanCache
	});

	return {
		props: {
			total: events.total,
			limit: params.limit,
			urlParams: _(allParams).omit('limit'),
			initialReduxState: { events },
			institutes
		}
	};
}

export default Institutes;
